const IDENTITY_PROVIDERS = {
  DUO: 'app-duo',
  GOOGLE: 'app-google-workspace',
}
const IDENTITY_PROVIDERS_ARRAY = Object.values(IDENTITY_PROVIDERS)

export { IDENTITY_PROVIDERS, IDENTITY_PROVIDERS_ARRAY }
